import { InputHandler } from '@maverick/hooks';
import { Icon, IconChevronDown, Loading } from '@maverick/ui';
import { FC, ChangeEvent } from 'react';

import * as Styled from './CmsDropdown.styled';

export interface DropdownItem {
	text: string;
	value: string;
	disabled?: boolean;
}

export interface CmsDropdownProps {
	handler: InputHandler<string>;
	items: Array<DropdownItem>;
	onChange?: (value: string) => void;
}
export const CmsDropdown: FC<CmsDropdownProps> = ({ handler, items, onChange }) => {
	const handleOnChange = (ev: ChangeEvent<HTMLSelectElement>) => {
		handler.setValue(ev.target.value);
		handler.onChange?.(ev.target.value);
		handler.setError('');
		onChange?.(ev.target.value);
	};

	const shouldRenderEmptyOption =
		!!handler.placeholder || (handler.value === '' && !items.find((option) => option.value === ''));
	return (
		<Styled.Container>
			{!!handler.label && <Styled.Label>{handler.label}</Styled.Label>}

			<Styled.Wrapper>
				<select value={handler.value} onChange={handleOnChange} disabled={handler.disabled}>
					{shouldRenderEmptyOption && (
						<option value='' disabled>
							{handler.placeholder}
						</option>
					)}
					{items.map(({ text, value, disabled }) => (
						<option value={value} disabled={disabled} key={value}>
							{text}
						</option>
					))}
				</select>
				<Styled.Chevron>
					{handler.loading ? <Loading size={16} /> : <Icon icon={IconChevronDown} customSize />}
				</Styled.Chevron>
			</Styled.Wrapper>
		</Styled.Container>
	);
};
